import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f900efa&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2f900efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f900efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f900efa')) {
      api.createRecord('2f900efa', component.options)
    } else {
      api.reload('2f900efa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f900efa&scoped=true&", function () {
      api.rerender('2f900efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/city-store-manage/modules/delivery-edit-log-dialog/index.vue"
export default component.exports